<template>
  <div>
    <h3 v-if="view === 'agendaWeek'" class="tw-font-bold tw-mb-4 tw-text-xl">
      Agenda de {{start && start.format('DD/MM/YYYY')}} a {{end && end.format('DD/MM/YYYY')}}
    </h3>
    <h3 v-else class="tw-font-bold tw-mb-4 tw-text-xl">
      Agenda do dia {{start && start.format('DD/MM/YYYY')}}
    </h3>
    <table class="table table-bordered tw-w-full" v-show="events.length > 0">
      <thead>
        <tr>
          <th>Atendimento</th>
          <th>Profissional</th>
          <th>Paciente</th>
          <th>Telefone</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="event in events" :key="event.id">
          <td>{{event.start && event.start.format("DD/MM/YY")}} <br> {{event.start && event.start.format("HH:mm")}} - {{event.end && event.end.format("HH:mm")}}</td>
          <td>{{event.professional_name}}</td>
          <td>

            <span v-if="event.type == 'Compromise'" class="tw-italic">Compromisso:</span>
            {{event.title}} <br>
            {{event.status}} <span v-if="event.observations"> <br> Obs: {{event.observations}}</span>
          </td>
          <td>{{event.patient_cellphone_formated}}</td>
        </tr>
      </tbody>
    </table>

    <p class="tw-font-semibold tw-mb-4 tw-text-lg" v-show="events.length === 0">Nenhum evento para o intervalo selecionado.</p>
  </div>
</template>
<script>
export default {
  data(){
    return {
      events: [],
      start: null,
      end: null,
      view: ""
    }
  },
  mounted() {
    document.addEventListener('calendar/print', this.getEvents);
  },
  beforeDestroy() {
    document.removeEventListener('calendar/print', this.getEvents);
  },
  updated(){
    window.print();
  },
  methods: {
    getEvents(event) {
      const startCalendar = event.detail.start
      const endCalendar = event.detail.end
      this.events = event.detail.events.filter((event) =>{
        return event.type != "Holiday" && event.start._d >= startCalendar._d && event.end._d <= endCalendar._d
      }).sort((a,b) =>{
        return a.start._d - b.start._d;
      });
      this.start = startCalendar
      this.end = endCalendar
      this.view = event.detail.view
    }
  }
}
</script>
